import useIsEditing from 'lib/hooks/useIsEditing';
import React from 'react';

export function EditingHelpText({
  children,
  className,
  inline,
  hideIf,
  ...props
}: React.PropsWithChildren &
  React.HTMLAttributes<HTMLElement> & { inline?: false; hideIf?: boolean }) {
  const isEditing = useIsEditing();
  if (!isEditing) {
    return <></>;
  }
  if (hideIf) {
    return <></>;
  }

  if (inline) {
    return (
      <span className={className + ' ee-help-text-block'} {...props}>
        {children}
      </span>
    );
  }
  return (
    <div className={className + ' ee-help-text-block'} {...props}>
      {children}
    </div>
  );
}
